import React from 'react';
import './Thumbnail.style.css';

const Thumbnail = ({
  size = 64,
  src = '',
  alt = '',
  onClick,
  filter = '',
  style = {},
}) => {
  /* ===== Route ===== */
  /* ===== Props ===== */
  /* ===== State ===== */
  /* ===== Hooks ===== */
  /* ===== Function ===== */
  /* ===== Variable ===== */
  /* ===== Hooks ===== */
  /* ===== Render ===== */
  return (
    <div
      className="thumbnail_layout"
      style={{
        width: size,
        height: size,
        cursor: onClick ? 'pointer' : 'default',
        ...style,
      }}
      onClick={() => (onClick && !filter ? onClick() : {})}
    >
      <img
        src={src}
        alt={alt ?? '상품 이미지'}
        width={'100%'}
        height={'100%'}
      />

      {filter && (
        <div
          className="thumbnail_filter"
          style={{ cursor: onClick && filter ? 'pointer' : 'default' }}
          onClick={() => (onClick && filter ? onClick() : {})}
        >
          {filter}
        </div>
      )}
    </div>
  );
};

export default Thumbnail;
